/** Shown in place of the middle of a long trail. */
const TRAIL_ELLIPSIS = '...';

/**
 * Folder path -> the breadcrumb segments to print, middle collapsed.
 *
 * A search result can live many folders deep, and the full trail is both too
 * long for a subtitle and mostly noise: what identifies a location is where it
 * STARTS (which top-level area) and where it ENDS (the folder the item is
 * actually in). Everything between is passage.
 *
 *   ''                    -> []                                  (root)
 *   '/Marketing'          -> ['Marketing']
 *   '/Marketing/Q3'       -> ['Marketing', 'Q3']
 *   '/A/B/C'              -> ['A', '...', 'C']
 *   '/A/B/C/D'            -> ['A', '...', 'D']
 *
 * Returns segments rather than a joined string so the caller owns the
 * separator and can translate the root case ("Home") itself.
 */
export function collapseLocationTrail(path: string | null | undefined): string[] {
  return collapseTrailSegments(
    (path ?? '')
      .split('/')
      .map((segment) => segment.trim())
      .filter(Boolean),
  );
}

/**
 * Same collapse rule over segments you already have.
 *
 * Folder rows use this: their trail starts with the SECTION the folder belongs
 * to ("Screens", "Files/Assets") followed by its path, and that combined list
 * needs collapsing exactly like a plain path does.
 */
export function collapseTrailSegments(segments: string[]): string[] {
  const parts = segments.map((segment) => segment.trim()).filter(Boolean);
  if (parts.length <= 2) return parts;
  return [parts[0] as string, TRAIL_ELLIPSIS, parts[parts.length - 1] as string];
}
